<template>
  <div class="full relative">
    <div class="full absolute" ref="force-3d"></div>
    <div class="absolute top-0 left-0">
      <input type="text" v-model="word" @keydown.enter="reload()" />
      <button @click="reload()">Load</button>
    </div>
  </div>
</template>

<script>
import * as API from '../../api/api'
import ForceGraph3D from '3d-force-graph'
import SpriteText from 'three-spritetext'

export default {
  data () {
    return {
      word: 'happy',
      Graph: false
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    reload () {
      if (this.Graph) {
        this.toGraphData().then(d => {
          d.links.forEach((link, idx) => {
            link.value = idx
          })
          this.Graph.graphData(d)
        })
      }
    },
    async toGraphData () {
      let words = await API.lookUp({ word: this.word })
      console.log(words)
      return words
      // let data = {
      //   nodes: [
      //     {
      //       id: 1,
      //       name: 'lok'
      //     },
      //     {
      //       id: 2,
      //       name: 'loklok'
      //     }
      //   ],
      //   links: [
      //     {
      //       source: 1,
      //       target: 2,
      //       color: '#4199a9'
      //     }
      //   ]
      // }
      // return data
    },
    loopUp () {

    },
    onClick (node) {
      console.log(node.word)
      this.word = node.word

      this.Graph.graphData({
        nodes: [
          { id: 1, word: 'Loading...' },
          { id: 2, word: 'Much love...' },
          { id: 3, word: 'Much love...' },
          { id: 4, word: 'Much love...' },
          { id: 5, word: 'Much love...' }
        ],
        links: [
          { source: 1, target: 2 },
          { source: 1, target: 3 },
          { source: 1, target: 4 },
          { source: 1, target: 5 }
        ]
      })
      this.reload()
    },
    async init () {
      const initData = await this.toGraphData()

      const elem = this.$refs['force-3d']
      const rect = elem.getBoundingClientRect()

      this.Graph = ForceGraph3D()(elem)
        // .dagMode('bu')
        .enableNodeDrag(true)
        .onNodeHover((node) => {
          elem.style.cursor = node ? 'pointer' : null
        })
        .onNodeClick(this.onClick)
        .graphData(initData)
        .nodeThreeObject((node) => {
          const sprite = new SpriteText(node.word)
          sprite.color = '#000000'
          sprite.textHeight = 5
          sprite.fontSize = 100
          sprite.fontFace = `'Inconsolata', 'Avenir', Helvetica, Arial, sans-serif`

          // correct emoji print
          const canvas = sprite._canvas
          const ctx = canvas.getContext('2d')

          const font = `normal ${sprite.fontSize * 0.9}px ${sprite.fontFace}`

          ctx.font = font
          const textWidth = ctx.measureText(sprite.text).width
          canvas.width = textWidth
          canvas.height = sprite.fontSize

          ctx.fillStyle = 'rgba(255,255,255,0.8)'
          ctx.fillRect(0, 0, canvas.width, canvas.height)

          ctx.font = font
          ctx.fillStyle = sprite.color
          ctx.textBaseline = 'bottom'
          ctx.fillText(sprite.text, 0, canvas.height)

          // Inject canvas into sprite
          sprite._texture.image = canvas
          sprite._texture.needsUpdate = true

          sprite.scale.set(sprite.textHeight * canvas.width / canvas.height, sprite.textHeight)
          sprite.material.transparent = true
          sprite.material.depthTest = true
          return sprite
        })
        .linkOpacity(0.5)
        .linkWidth(0.2)
        .linkResolution(5)
        // .linkDirectionalParticles(5)
        // .linkDirectionalParticleWidth(0.8)
        // .linkDirectionalParticleSpeed(0.006)

      let renderer = this.Graph.renderer()
      renderer.setPixelRatio(2.0)
      this.Graph.backgroundColor('#101010')
      this.Graph.width(rect.width)
      this.Graph.height(rect.height)

      window.addEventListener('resize', () => {
        const elem = this.$refs['force-3d']
        if (elem) {
          const rect = elem.getBoundingClientRect()
          this.Graph.width(rect.width)
          this.Graph.height(rect.height)
        }
      })
    }
  }
}
</script>

<style>

</style>
